import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

@Injectable()
export class SmsVerifyService {
  constructor (private http: Http) {}

  sendCodeUid () {
    return this.http.post('/user/send_code_uid', {})
  }

  sendCode (mobile: string) {
    return this.http.post('/user/send_code', { mobile })
  }
}
